const HDR_ACTIVATION_POINT = 1024;
const HDR_ACTIVATION_POINT_UE = 768;

const SCROLL_LIMIT = 156;

function closeMobileNavigation() {
	document.documentElement.classList.remove("c-nav-open");
	document.documentElement.classList.remove("scroll-lock");
	document.body.classList.remove("scroll-lock");
	document.body.classList.remove("c-nav-open");

	document.querySelectorAll("header.component-header").forEach(($item) => {
		$item.classList.remove("menu-open");
	});

	document.querySelectorAll("nav.c-nav__navigation").forEach(($item) => {
		$item.classList.remove("dropdown-is-active");
	});

	document.querySelectorAll(".c-nav-close").forEach(($item) => {
		$item.classList.remove("dropdown-is-active");
	});

	resetMobileNavigation();
}

function openMobileNavigation() {
	document.documentElement.classList.add("scroll-lock");
	document.documentElement.classList.add("c-nav-open");
	document.body.classList.add("c-nav-open");
	document.body.classList.add("scroll-lock");

	document.querySelectorAll("header.component-header").forEach(($item) => {
		$item.classList.add("menu-open");
	});

	document.querySelectorAll("nav.c-nav__navigation").forEach(($item) => {
		$item.classList.add("dropdown-is-active");
	});

	document.querySelectorAll(".c-nav-close").forEach(($item) => {
		$item.classList.add("dropdown-is-active");
	});

	resetMobileNavigation();
}

function resetMobileNavigation() {
	document.querySelectorAll("nav.c-nav__navigation").forEach(($item) => {
		$item.classList.remove("secondary-list-view");
	});

	document.querySelectorAll(".c-nav__navigation--primary-list").forEach(($item) => {
		$item.classList.remove("moveOut");
	});

	document.querySelectorAll(".c-nav__navigation--featured-links").forEach(($item) => {
		$item.classList.remove("moveOut");
	});

	// check this, need to remove class somewhere, used to be jquery.hide()
	document.querySelectorAll(".c-nav__navigation--secondary-list div.group").forEach(($item) => {
		$item.classList.add("hidden");
	});

	document.querySelectorAll(".c-nav__navigation--secondary-list").forEach(($item) => {
		$item.classList.add("hidden");
	});
}

export { closeMobileNavigation, openMobileNavigation, HDR_ACTIVATION_POINT, HDR_ACTIVATION_POINT_UE, SCROLL_LIMIT };
